<!-- Yeah I know, the name, slight oversight -->

<div class="title">
    <p><b>I See It, I Like It, I Want It...</b></p>
</div>
<div class="container">

    <table class="table table-hover student-details-table-width">


        <!-- <th>I See It, I Like It, I Want It...</th>
        <th></th>
        <th></th> -->


        <tr class="header" *ngFor="let plant of wishlist">

            <td class="plant-name">{{plant.name | titlecase}}</td>

            <!-- <td><button class="btn text-warning" (click)="onEdit(plant)"><i class="fa fa-edit"
                        title="Edit"></i>Opps</button></ td> -->
            <td><button class="btn" (click)="onDelete(plant)"><i class="fa fa-trash" title="Remove"></i>I
                    Got It</button></td>

        </tr>
       
    </table>

    <div class="error" *ngIf="deleteMessage">
        <h5 class="text-dark">{{ deleteMessage | titlecase }}</h5>
    </div>

</div>